module.exports = __webpack_public_path__ + "img/me_after_sales_icon备份 3.fe492699.svg";